<div class="d-flex flex-column flex-md-row justify-content-around">
    <div class="form-group ">
        <label for="">Choisir la classe</label>
        <select class="mx-1 form-control" (change)="loadCourses($event)" >
            <option selected disabled></option>
            <option *ngFor="let pacc of paccs" [value]="pacc?.id">{{pacc?.classroom?.name}}</option>
        </select>
    </div>
    <div class="form-group ">
        <label for="">Choisir la matière</label>
        <select class="mx-1 form-control" (change)="loadCompositions1($event)">
            <option selected disabled></option>
            <option *ngFor="let c of courses" [value]="c?.id">{{c?.name}}</option>
        </select>
    </div>
    <div class="form-group ">
        <label for="">Choisir la période</label>
        <select class="mx-1 form-control" [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
    </div>
    <!-- <div class="form-group ">
        <label for="">Choisir la composition</label>
        <select class="mx-1 form-control" ngModel name="composition_id" (change)="loadNotes($event)">
            <option selected disabled></option>
            <option *ngFor="let c of compositions" [value]="c?.id">{{c?.name}}</option>
        </select>
    </div> -->
</div>
<div class="text-center">
    <p class="text-center text-info h6" *ngIf="!canSetAppreciation" >Vous ne pouvez pas saisir d'appréciation pour l'instant</p>

 </div>

<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row no-gutters p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <!-- <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">#</span>
                </div> -->
                <div class="col-md-5 col-12">
                    <span class="text-white align-self-center">Elèves</span>
                </div>
                <div class="col-md-1 col-12 text-center">
                    <span class="text-white  align-self-center">Retard</span>
                </div>
                <div class="col-md-1 col-12">
                    <span class="text-white text-center align-self-center">Absences</span>
                </div>
                <div class="col-md-1 col-12 ">
                    <span class="text-white text-center align-self-center">Moyenne</span>
                </div>
                <div class="col-md-4 col-12">
                    <span class="text-white align-self-center">Appréciation</span>
                </div>
            </div>
              
            <div class="" style="height: 65vh; overflow-y: scroll; ">
                <table class="table table-sm table-striped  table-borderless">
                   <tbody>
                    <tr class="d-flex flex-column flex-md-row row align-items-start no-gutters px-1" *ngFor="let d of data; let i=index">
                        <!-- <td class="col-md-1 col-12">
                            <div class="">
                                {{i+1}}
                            </div>
                        </td> -->
                        <td class="col-md-5 col-12 d-flex" >
                            <p class="text-dark h6 text-center text-md-left align-self-center"><strong>{{d.lastname}}</strong> {{d.firstname}}</p>

                            <!-- <div class=" d-flex">
                                <img src="assets/avatar.jpg" height="50" width="50" class="img-thumbnail" alt="..."> 
                                <div class=" align-self-center">
                                    <span class="text-dark h6 text-center"><strong><small>{{d.student}}</small></strong></span>
                                </div>
                                </div>-->
                        </td>
                        <td class="col-md-1 col-12 d-flex justify-content-center">
                            <p class="align-self-center">{{d.late}}</p>
                            
                        </td>
                        <td class="col-md-1 col-12 d-flex justify-content-center">
                            <p class="align-self-center">{{d.missed}}</p>

                            
                        </td>
                        <td class="col-md-1 col-12 d-flex justify-content-center">
                            <p class="align-self-center">{{d.moy | number:".2"}}</p>

                            
                        </td>
                        <td class="col-md-4 col-12 d-flex">
                            <textarea name="appreciation" [(ngModel)]="d.appreciation"  rows="1" class="form-control" [readonly]="!canSetAppreciation"></textarea>
                        </td>
                    </tr>
                   </tbody>
                </table>
                <div class="text-center">
                    <button *ngIf="canSetAppreciation" (click)="setAppreciation()" class="btn btn-sm btn-primary">Enregistrer mes appréciations</button>
                </div>
            </div>
        </div>
    </div>
</div>


